// rules/rule-0063-two-specialists.ts
import { AdjustedLine, ModifierContext } from '../modifier-models';
import { BaseRule } from '../rule-base';

export class Rule0063TwoSpecialists extends BaseRule {
    name = '0063 two-specialist share ⅔';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (!line.modifiers?.includes('0063')) return;

        const newUnits = line.adjustedUnits * (2 / 3);
        
        if (autoApply) {
            line.adjustedUnits = newUnits;
            line.trace.push('0063 ×0.6667');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0063',
                message: '⅔ reduction for two-specialist sharing',
                kind: 'overwrite',
                unitsDelta: newUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext): AdjustedLine[] {
        lines
            .filter(l => l.modifiers?.includes('0063'))
            .forEach(l => {
                l.adjustedUnits *= 2 / 3;
                l.trace.push('0063 ×0.6667');
            });
        return lines;
    }
}
